'use client';

import React from 'react';
import * as FeatherIcons from 'react-feather';
import { HelpCircle } from 'react-feather';

type IconSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const sizeMap: Record<IconSize, number> = {
  xs: 14,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
};

interface IconProps {
  name: string;
  size?: IconSize;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  [key: string]: any;
}

function Icon({
  name,
  size = 'md', // ✅ default is now semantic
  className = '',
  onClick,
  disabled = false,
  ...props
}: IconProps) {
  const IconComponent = FeatherIcons[
    name as keyof typeof FeatherIcons
  ] as React.ComponentType<any>;

  const pixelSize = sizeMap[size];

  const baseClasses = [
    disabled
      ? 'opacity-50 cursor-not-allowed'
      : onClick
        ? 'cursor-pointer hover:opacity-80'
        : '',
    className,
  ].join(' ');

  if (!IconComponent) {
    return (
      <HelpCircle
        size={pixelSize}
        className={`text-gray-400 ${baseClasses}`}
        onClick={disabled ? undefined : onClick}
        {...props}
      />
    );
  }

  return (
    <IconComponent
      size={pixelSize}
      className={baseClasses}
      onClick={disabled ? undefined : onClick}
      {...props}
    />
  );
}

export default Icon;
